import React from 'react';
import ReactDOM from 'react-dom/client';
import Search from "../components/search/search";
import Listing from "../components/listing/listing";
import AwardListing from "../components/award_listing/award_listing";
import Form from "../components/search_form/search_form";
import Saved from "../components/saved/saved";
import InterestForm from "../components/interest_form/interest_form";
import {BrowserRouter as Router} from 'react-router-dom';
import RecentlyViewedTracker from "../components/recently_viewed/recently_viewed_tracker";
import RecentlyViewedInit from "../components/recently_viewed/recently_viewed_init";
import CardSlider from "../components/card_slider/card_slider"


(() => {

  function renderSearchListing() {
    const domEls = document.querySelectorAll('.search__api');
    if (domEls.length) {
      domEls.forEach(el => {
        let root = ReactDOM.createRoot(el);
        root.render(<Router><Search el={el} api={el.dataset.api}/></Router>);
      });
    }
  }

  function globalSearchForm() {
    const domEls = document.querySelectorAll('.searchform__api');
    if (domEls.length) {
      domEls.forEach(el => {
        let root = ReactDOM.createRoot(el);
        root.render(<Form api={el.dataset.api}/>);
      });
    }
  }

  function triggerSaved() {
    const domEls = document.querySelectorAll('.card__toggle-save');
    if (domEls.length) {
      domEls.forEach(el => {
        let root = ReactDOM.createRoot(el);
        root.render(<Saved api={el.dataset.api} user={el.dataset.user} hasSaved={el.dataset.saved} title={el.dataset.title} />);
      });
    }
  }

  function renderListing() {
    const domEls = document.querySelectorAll('.listing__api');
    if (domEls.length) {
      domEls.forEach(el => {
        let root = ReactDOM.createRoot(el);
        root.render(<Router><Listing el={el} api={el.dataset.api}/></Router>);
      });
    }
  }

  function awardListing() {
    const domEls = document.querySelectorAll('.award-listing__api');

    if (domEls.length) {
      domEls.forEach(el => {
        let root = ReactDOM.createRoot(el);
        root.render(<Router><AwardListing api={el.dataset.api}/></Router>);
      });
    }
  }

  function renderInterestForm() {

    const domEls = document.querySelectorAll('.interest-form');
    if (domEls.length) {
      domEls.forEach(el => {
        let root = ReactDOM.createRoot(el);
        root.render(<InterestForm api={el.dataset.api} />);
      });
    }
  }

  triggerSaved();
  renderSearchListing();
  globalSearchForm();
  renderListing();
  awardListing();
  renderInterestForm();
  RecentlyViewedTracker();
  RecentlyViewedInit();
})();
